/**
 * Copyright Highway9 Networks Inc.
 */

import { createCache, fetchCache } from "./cache";
import { fetchWithInFlightDedupe, getInFlightDedupeKey } from "./fetchInFlightDedupe";
import {
  applyRequestInterceptors,
  applyResponseInterceptors,
  processFetchError,
} from "./fetchInterceptors";

const ENV_PROXY = import.meta.env.H9_API_PROXY_URL;
const isDev = window.location.host.includes("localhost");
const shouldUseFakeBackend = import.meta.env.DEV && !ENV_PROXY && isDev;
//uncomment below line and line number 22,56 to use both local fake backend and proxy
//const excludeEndpointsFromRealFetch = ["/api/v1/orch/operatorRadios/query"]; //Add the endpoint which you want to get the data from local fake backend.

export const realFetch = window.fetch.bind(window);

export function configureFetch() {
  window.fetch = function (url, opts) {
    const src = url.toString();
    const options = opts || {};

    return new Promise((resolve, reject) => {
      void (async () => {
        try {
          //if not local, then make real calls.
          //if (!excludeEndpointsFromRealFetch.includes(url)) {
          if (!shouldUseFakeBackend) {
            const isCached = await fetchCache(src, options, resolve, reject);
            if (isCached) {
              return;
            }

            const [reqUrl, reqInit] = await applyRequestInterceptors(url, options);
            const dedupeKey = getInFlightDedupeKey(reqUrl, reqInit);
            const response = await fetchWithInFlightDedupe(dedupeKey, async () => {
              let r = await realFetch(reqUrl, reqInit);
              if (r.ok) {
                r = await applyResponseInterceptors(r);
              }
              return r;
            });

            if (!response.ok) {
              throw response;
            }
            // if response is ok and method is GET then add it in cache object
            createCache(src, options, response, resolve, reject);
            return;
          }
          // }
          // Keep fake backend strictly dev-only and out of production chunk graph.
          const fakeBackendModulePath = "/src/helpers/config/fake-backend.ts";
          const { getFakeData } = await import(
            /* @vite-ignore */ fakeBackendModulePath
          );
          getFakeData(src, options, resolve, reject);
        } catch (err) {
          await processFetchError(err, reject);
        }
      })();
    });
  };
}
